import axios, { AxiosInstance } from "axios";

// Utility to remove trailing slash..
const removeTrailingSlash = (url: string): string => url.replace(/\/$/, "");

// Define runtime config shape
interface RuntimeConfig {
  VITE_API_BASEURL?: string;
  VITE_API_VERSION?: string;
  VITE_AXIOS_TIMEOUT?: string | number;
  VITE_AXIOS_GENERATE_PACKET_TIMEOUT?: string | number;
  [key: string]: string | number | undefined;
}

// Direct access to Vite environment variables
async function loadRuntimeConfig(): Promise<RuntimeConfig> {
  let fileConfig: RuntimeConfig = {};
  try {
    const res = await fetch("/config/config.json", { method: "GET" });
    if (res.ok) {
      fileConfig = await res.json();
    } else {
      console.warn("Runtime config fetch failed (status)", res.status);
    }
  } catch (err) {
    console.warn("Runtime config fetch error", err);
  }
  return fileConfig;
}
export const config = await loadRuntimeConfig();
const API_BASEURL = config?.VITE_API_BASEURL ?? import.meta.env.VITE_API_BASEURL ?? "";
const API_VERSION_ = config?.VITE_API_VERSION ?? import.meta.env.VITE_API_VERSION ?? "";
const AXIOS_TIMEOUT = Number(config?.VITE_AXIOS_TIMEOUT) || Number(import.meta.env.VITE_AXIOS_TIMEOUT) || 30000;
export const AXIOS_GENERATE_PACKET_TIMEOUT = Number(config?.VITE_AXIOS_GENERATE_PACKET_TIMEOUT) || Number(import.meta.env.VITE_AXIOS_GENERATE_PACKET_TIMEOUT) || 20000;

// Create Axios client factory
const createAxiosClient = (
    baseURL: string,
    timeout: number = AXIOS_TIMEOUT
): AxiosInstance => {
    const client = axios.create({
        baseURL,
        timeout,
        headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
        },
    });
    return client;
};

const API_BASE_URL = removeTrailingSlash(API_BASEURL);
const API_VERSION = removeTrailingSlash(API_VERSION_);
const fullApiUrl = `${API_BASE_URL}${API_VERSION}`;

const axiosClient = createAxiosClient(fullApiUrl, AXIOS_TIMEOUT);
const axiosClientGeneratePacket = createAxiosClient(fullApiUrl, AXIOS_GENERATE_PACKET_TIMEOUT);

export { axiosClient, axiosClientGeneratePacket };